import { render, staticRenderFns } from "./DeleteBaseRateModal.vue?vue&type=template&id=8bd7ea2c&scoped=true&"
import script from "./DeleteBaseRateModal.vue?vue&type=script&lang=js&"
export * from "./DeleteBaseRateModal.vue?vue&type=script&lang=js&"
import style0 from "./DeleteBaseRateModal.vue?vue&type=style&index=0&id=8bd7ea2c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bd7ea2c",
  null
  
)

export default component.exports